var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconHeart01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "M21 6.413a4.977 4.977 0 0 0-7.041 0l-.96.96-.959-.96A4.979 4.979 0 1 0 5 13.454l.959.96 7.04 7.04 7.042-7.04.959-.96a4.975 4.975 0 0 0 0-7.04"
})));
export default SvgIconHeart01;